import React from 'react';
import PropTypes from 'prop-types';
import { Container, Grid, List, ListItem, ListItemText, Paper } from '@mui/material';
import { Button, Typography } from 'cprime-foundational-components';
import * as S from './ErrorCard.styles';
import CubeError from '../../assets/CubeError.svg';

const actionMapping = {
  requestAccess: {
    buttonText: 'Request Access',
    onClick: () =>
      window.open(
        'https://tmna.service-now.com/1ts?id=sc_cat_item&table=sc_cat_item&sys_id=e05d48b01b3aed1070beda01dd4bcb7f',
      ),
  },
};

const ErrorCard = ({ message, details, action, steps, subDetails }) => (
  <Container disableGutters maxWidth="tablet">
    <Paper elevation={0}>
      <Grid container p={2}>
        <Grid item tablet={3}>
          <S.StyledImage src={CubeError} />
        </Grid>
        <Grid container flexDirection="column" justifyContent="center" tablet={9}>
          <Typography variant="h2" component="p" mb={3}>
            {message}
          </Typography>
          <Typography variant="h3" component="p" mb={1}>
            {details}
          </Typography>
          <Typography variant="h3" component="p" color="text.disabled">
            {subDetails}
          </Typography>
          {steps && (
            <List sx={{ pl: 2, mb: 2 }}>
              {steps.map((step, i) => (
                <ListItem key={i} sx={{ p: 0 }}>
                  <ListItemText
                    primary={`${i + 1}. ${step}`}
                    primaryTypographyProps={{ fontWeight: 400 }}
                  />
                </ListItem>
              ))}
            </List>
          )}
          {action && actionMapping[action] && (
            <Button
              variant="primary"
              sx={{ width: '8.5rem', mb: 2 }}
              onClick={actionMapping[action].onClick}
            >
              {actionMapping[action].buttonText}
            </Button>
          )}
        </Grid>
      </Grid>
    </Paper>
  </Container>
);

ErrorCard.propTypes = {
  message: PropTypes.string,
  details: PropTypes.string,
  subDetails: PropTypes.string,
  action: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.string),
};

export default ErrorCard;
